"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const dummy_png_1 = __importDefault(require("@app/image/dummy.png"));
const no_name_png_1 = __importDefault(require("@app/image/no-name.png"));
const body_scss_1 = __importDefault(require("@app/style/body.scss"));
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const Avatar = ({ profile, size }) => {
    const fsize = parseInt(body_scss_1.default.fontsizepx, 10) / 16;
    const computedSize = fsize * (size || 40);
    const getDefaultInitials = (name) => {
        const maxInitials = 3;
        return name
            .split(/\s/)
            .map((part) => part.substring(0, 1).toUpperCase())
            .filter((v) => !!v)
            .slice(0, maxInitials)
            .join('')
            .toUpperCase();
    };
    const getImageSize = (size) => {
        const s = parseFloat(size.toString());
        return s.toString() + 'px';
    };
    const getAvatarHTML = ({ className, name, src, size, }) => (react_1.default.createElement("div", { "data-testid": 'avatar', className: className, style: {
            display: 'inline-block',
            verticalAlign: 'middle',
            width: getImageSize(size),
            height: getImageSize(size),
        } }, name ? (react_1.default.createElement("div", { className: className, title: name, style: {
            lineHeight: 'initial',
            textAlign: 'center',
            color: 'white',
            background: body_scss_1.default.iconblue,
            width: getImageSize(size),
            height: getImageSize(size),
        } },
        react_1.default.createElement("div", { style: {
                display: 'table',
                tableLayout: 'fixed',
                width: '100%',
                height: '100%',
                fontSize: (0.33 * size).toString() + 'px',
            } },
            react_1.default.createElement("span", { style: {
                    display: 'table-cell',
                    verticalAlign: 'middle',
                    whiteSpace: 'nowrap',
                } },
                react_1.default.createElement("span", null, getDefaultInitials(name)))))) : (react_1.default.createElement("img", { className: className, src: src, style: {
            maxWidth: '100%',
            width: getImageSize(size),
            height: getImageSize(size),
        } }))));
    if (!profile) {
        return (react_1.default.createElement("div", { className: "ds-avatar-title", title: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ASSIGN')) }, getAvatarHTML({
            className: 'ds-avatar is-dummy',
            src: no_name_png_1.default,
            size: computedSize,
        })));
    }
    if (profile.dummy) {
        return (react_1.default.createElement("div", { className: "ds-avatar-title", title: profile.name }, getAvatarHTML({
            className: 'ds-avatar is-dummy',
            src: dummy_png_1.default,
            size: computedSize,
        })));
    }
    if (!profile.firstName) {
        return (react_1.default.createElement("div", { className: "ds-avatar-title", title: profile.email }, getAvatarHTML({
            className: 'ds-avatar is-dummy',
            src: no_name_png_1.default,
            size: computedSize,
        })));
    }
    const regex = /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{2600}-\u{26FF}]/gu;
    const cleanName = profile.name?.replace(regex, '') || '';
    return (react_1.default.createElement("div", { className: "ds-avatar-title", title: profile.email }, getAvatarHTML({
        className: 'ds-avatar is-user',
        name: cleanName,
        size: computedSize,
    })));
};
exports.Avatar = Avatar;
